import { usersIcon, loginIcon } from "@excalidraw/excalidraw/components/icons";
import { MainMenu } from "@excalidraw/excalidraw/index";
import React from "react";

import type { Theme } from "@excalidraw/element/types";

import { LanguageList } from "../app-language/LanguageList";
import { useAtom, useAtomValue, useSetAtom } from "../app-jotai";
import { authApi } from "../data/api";
import {
  authPageStateAtom,
  currentUserAtom,
  dashboardOpenAtom,
} from "../data/authState";
import { workspacePath } from "../data/workspaceRoutes";

import "./AppMainMenu.scss";

export const AppMainMenu: React.FC<{
  theme: Theme | "system";
}> = React.memo((props) => {
  const currentUser = useAtomValue(currentUserAtom);
  const setAuthPageState = useSetAtom(authPageStateAtom);
  const setCurrentUser = useSetAtom(currentUserAtom);
  const [, setDashboardOpen] = useAtom(dashboardOpenAtom);

  return (
    <MainMenu>
      {currentUser ? (
        <>
          {currentUser.role === "USER" && (
            <MainMenu.Item
              icon={usersIcon}
              onSelect={() => {
                window.history.pushState(
                  {},
                  document.title,
                  workspacePath(currentUser.publicId),
                );
                setDashboardOpen(true);
              }}
            >
              My screens
            </MainMenu.Item>
          )}
          <MainMenu.Item
            icon={loginIcon}
            onSelect={() => {
              authApi.logout().finally(() => setCurrentUser(null));
            }}
          >
            {`Log out (${currentUser.email})`}
          </MainMenu.Item>
        </>
      ) : (
        <>
          <MainMenu.Item
            icon={usersIcon}
            className="AppMainMenu__accountItem AppMainMenu__accountItem--primary"
            onSelect={() => {
              window.history.pushState({}, document.title, "/signup");
              setAuthPageState({ isOpen: true, mode: "signup" });
            }}
          >
            Sign up
          </MainMenu.Item>
          <MainMenu.Item
            icon={loginIcon}
            className="AppMainMenu__accountItem"
            onSelect={() => {
              window.history.pushState({}, document.title, "/login");
              setAuthPageState({ isOpen: true, mode: "login" });
            }}
          >
            Log in
          </MainMenu.Item>
        </>
      )}
      <MainMenu.Separator />
      <MainMenu.DefaultItems.LoadScene />
      <MainMenu.DefaultItems.SaveToActiveFile />
      <MainMenu.DefaultItems.Export />
      <MainMenu.DefaultItems.SaveAsImage />
      <MainMenu.DefaultItems.CommandPalette className="highlighted" />
      <MainMenu.DefaultItems.SearchMenu />
      <MainMenu.DefaultItems.Help />
      <MainMenu.DefaultItems.ClearCanvas />
      <MainMenu.Separator />
      <MainMenu.DefaultItems.Preferences />
      <MainMenu.DefaultItems.ToggleTheme allowSystemTheme theme={props.theme} />
      <MainMenu.ItemCustom>
        <LanguageList style={{ width: "100%" }} />
      </MainMenu.ItemCustom>
      <MainMenu.DefaultItems.ChangeCanvasBackground />
    </MainMenu>
  );
});
